import React, { useState } from 'react'
import emailjs from '@emailjs/browser'

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  })
  const [status, setStatus] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus('sending')

    try {
      const result = await emailjs.send(
        'service_3izbhsc',
        'template_h24fgey',
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        'mK9rtWatFAvc8UGYr'
      )

      if (result.text === 'OK') {
        setStatus('success')
        setFormData({ name: '', email: '', subject: '', message: '' })
      }
    } catch (error) {
      setStatus('error')
    }
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1865a5] focus:border-[#1865a5] outline-none"
            required
          />
        </div>
        <div>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1865a5] focus:border-[#1865a5] outline-none"
            required
          />
        </div>
        <div>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Subject"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1865a5] focus:border-[#1865a5] outline-none"
            required
          />
        </div>
        <div>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message"
            rows={6}
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1865a5] focus:border-[#1865a5] outline-none resize-none"
            required
          />
        </div>
        <div>
          <button
            type="submit"
            disabled={status === 'sending'}
            className="w-full bg-[#1865a5] text-white py-3 px-6 rounded-lg hover:bg-[#16476e] transition duration-300 disabled:opacity-50"
          >
            {status === 'sending' ? 'Sending...' : 'Send Message'}
          </button>
        </div>
        {status === 'success' && (
          <div className="text-green-600 text-center">
            Message sent successfully!
          </div>
        )}
        {status === 'error' && (
          <div className="text-red-600 text-center">
            Failed to send message. Please try again.
          </div>
        )}
      </form>
    </div>
  )
}

export default ContactForm
